// src/components/BoardOfEd/components/Program1900.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_1900_CONFIG = {
  fullName: "LIBRARY MEDIA",
  docId: "1900",

  fieldDefs: [
    // POSITIONS (FTE)
    {
      key: "positionsMediaSpecialists",
      label: "Positions – Media Specialists",
      valueType: "count",
      sources: [
        { block: "Positions", key: "Media Specialists" },
        { block: "Positions", key: "LIBRARIANS/MEDIA SPECIALISTS" },
      ],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsParaeducators",
      label: "Positions – Paraeducators",
      valueType: "count",
      sources: [
        { block: "Positions", key: "Paraeducators" },
        { block: "Positions", key: "PARAEDUCATORS" },
      ],
      group: "positions",
      defaultVisible: false,
    },

    // SALARIES
    {
      key: "salariesMediaSpecialists",
      label: "Salaries – Media Specialists",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Media Specialists" },
        { block: "Salaries", key: "LIBRARIANS/MEDIA SPECIALISTS" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesParaeducators",
      label: "Salaries – Paraeducators",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Paraeducators" },
        { block: "Salaries", key: "PARAEDUCATORS" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSummerCertifiedClassified",
      label: "Salaries – Summer, Certified / Classified",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Summer, Certified / Classified" },
        { block: "Salaries", key: "SUMMER, CERTIFIED/CLASSIFIED" },
      ],
      group: "salaries",
      defaultVisible: false,
    },

    // SUPPLIES / MATERIALS
    {
      key: "instructionalMaterials",
      label: "Instructional Materials",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Instructional Materials" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "technologySoftware",
      label: "Technology – Software",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Technology Software" },
        { block: "Supplies / Materials", key: "Technology - Software" },
      ],
      group: "materials",
      defaultVisible: false,
    },

    // OTHER
    {
      key: "duesFees",
      label: "Dues / Fees",
      valueType: "currency",
      sources: [
        { block: "Other", key: "Dues and Fees" },
        { block: "Other", key: "Dues/Fees" },
        { block: "Other", key: "Dues / Fees" },
      ],
      group: "other",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approved",
      title: "1900 LIBRARY MEDIA – Approved",
      sectionKey: "Approved",
      fields: [
        "positionsMediaSpecialists",
        "positionsParaeducators",
        "salariesMediaSpecialists",
        "salariesParaeducators",
        "salariesSummerCertifiedClassified",
        "instructionalMaterials",
        "technologySoftware",
        "duesFees",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsMediaSpecialists: { minWidth: "150px" },
        positionsParaeducators: { minWidth: "150px" },

        // Salaries
        salariesMediaSpecialists: { minWidth: "170px" },
        salariesParaeducators: { minWidth: "150px" },
        salariesSummerCertifiedClassified: { minWidth: "190px" },

        // Materials / Other
        instructionalMaterials: { minWidth: "150px" },
        technologySoftware: { minWidth: "150px" },
        duesFees: { minWidth: "110px" },
      },
    },
    {
      id: "actual",
      title: "1900 LIBRARY MEDIA – Actual",
      sectionKey: "Actual",
      fields: [
        "positionsMediaSpecialists",
        "positionsParaeducators",
        "salariesMediaSpecialists",
        "salariesParaeducators",
        "salariesSummerCertifiedClassified",
        "instructionalMaterials",
        "technologySoftware",
        "duesFees",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsMediaSpecialists: { minWidth: "150px" },
        positionsParaeducators: { minWidth: "150px" },

        // Salaries
        salariesMediaSpecialists: { minWidth: "170px" },
        salariesParaeducators: { minWidth: "150px" },
        salariesSummerCertifiedClassified: { minWidth: "190px" },

        // Materials / Other
        instructionalMaterials: { minWidth: "150px" },
        technologySoftware: { minWidth: "150px" },
        duesFees: { minWidth: "110px" },
      },
    },
  ],
};

export function Program1900(props) {
  return (
    <ProgramBudget programId="1900" config={PROGRAM_1900_CONFIG} {...props} />
  );
}
